module.exports = __webpack_public_path__ + "static/media/location.3628e1f7.svg";